module.exports = __webpack_public_path__ + "static/data-analytics-4-fe390194557c7b14dac3c5757cbffd1a.svg";